export default "__VITE_ASSET__xfrwEzI5__"